interface TimeObject {
  hour: string;
  minute: string;
}

function convertTo24HourFormatObject(timeString: string): TimeObject {
  let hours: number;
  let minutes: number;

  const hasAMPM =
    timeString.toUpperCase().includes('AM') ||
    timeString.toUpperCase().includes('PM');

  if (hasAMPM) {
    const [time, period] = timeString.split(' ');
    [hours, minutes] = time.split(':').map(Number);

    if (period.toUpperCase() === 'PM' && hours !== 12) {
      hours += 12;
    } else if (period.toUpperCase() === 'AM' && hours === 12) {
      hours = 0;
    }
  } else {
    [hours, minutes] = timeString.split(':').map(Number);
  }

  return {
    hour: String(hours).padStart(2, '0'),
    minute: String(minutes).padStart(2, '0'),
  };
}

export default convertTo24HourFormatObject;
